/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/books.scss';
import Paging from '../../component/Inc/Paging';
import Tab from '../../component/Inc/Tab';

const PRStudentList = () => {
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '시범강의', value: 0},
    {title: '홍보책자', value: 1},
    {title: '수업등록', value: 2},
    {title: '등록 실패', value: 3, type: 'red'}
  ];
  return (
    <main className="com_container p_pr_student_list">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu7_8">홍보학생 목록</h2>
        </section>
        <section className="com_pg_container">
          <section className="box">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} tabStyle="fit_cont" />
              <section className="com_board_search end">
                <div className="com_btn_wrap">
                  <button className="com_btn line gray s active">오늘</button>
                  <button className="com_btn line gray s">1개월</button>
                  <button className="com_btn line gray s">3개월</button>
                </div>
                <div className="date_wrap">
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <span className="divider"> ~ </span>
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                </div>
                <article className="search">
                  <button className="com_btn gray ws s">조회</button>
                </article>
              </section>
            </div>
            <hr className="com_divider" />
            <div className="com_board_list__top">
              <section className="com_board_search end">
                <article className="search">
                  <input type="search" placeholder="학생명 검색" className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="7%" />
                <col width="12%" />
                <col width="8%" />
                <col width="8%" />
                <col width="12%" />
                <col width="8%" />
                <col width="8%" />
                <col width="12%" />
                <col width="12%" />
                <col width="12%" />
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>등록일</th>
                  <th>학생 명</th>
                  <th>부모 명</th>
                  <th>전화번호</th>
                  <th>수신자</th>
                  <th>홍보자</th>
                  <th>시범강의 여부</th>
                  <th>홍보 책자 발송</th>
                  <th>홍보 책자 발송</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>17</td>
                  <td className="td_date">2023, 05, 20 12 : 30</td>
                  <td>김학생</td>
                  <td>김부모</td>
                  <td>010-1234-1324</td>
                  <td>
                    <button className="btn_link">가길동201</button>
                  </td>
                  <td>
                    <button className="btn_link">가길동201</button>
                  </td>
                  <td>
                    김담임103
                    <br />
                    2023, 01, 05
                  </td>
                  <td>
                    튼튼 홍보자료
                    <br />
                    2023, 01, 05
                  </td>
                  <td className="td_point">-</td>
                </tr>
                <tr>
                  <td>16</td>
                  <td className="td_date">2023, 05, 20 12 : 30</td>
                  <td>김학생</td>
                  <td>김부모</td>
                  <td>010-1234-1324</td>
                  <td>
                    <button className="btn_link">가길동201</button>
                  </td>
                  <td>
                    <button className="btn_link">가길동201</button>
                  </td>
                  <td>
                    김담임103
                    <br />
                    2023, 01, 05
                  </td>
                  <td>
                    튼튼 홍보자료
                    <br />
                    2023, 01, 05
                  </td>
                  <td className="td_point">-</td>
                </tr>
                <tr className="selected">
                  <td>15</td>
                  <td className="td_date">2023, 05, 20 12 : 30</td>
                  <td>김학생</td>
                  <td>김부모</td>
                  <td>010-1234-1324</td>
                  <td>
                    <button className="btn_link">가길동201</button>
                  </td>
                  <td>
                    <button className="btn_link">가길동201</button>
                  </td>
                  <td>
                    김담임103
                    <br />
                    2023, 01, 05
                  </td>
                  <td>
                    튼튼 홍보자료
                    <br />
                    2023, 01, 05
                  </td>
                  <td>
                    <button className="btn_link blue">
                      승인
                      <br />
                      2023, 05, 12
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>14</td>
                  <td className="td_date">2023, 05, 20 12 : 30</td>
                  <td>김학생</td>
                  <td>김부모</td>
                  <td>010-1234-1324</td>
                  <td>
                    <button className="btn_link">가길동201</button>
                  </td>
                  <td>
                    <button className="btn_link">가길동201</button>
                  </td>
                  <td>
                    김담임103
                    <br />
                    2023, 01, 05
                  </td>
                  <td>
                    튼튼 홍보자료
                    <br />
                    2023, 01, 05
                  </td>
                  <td>
                    <button className="btn_link red">
                      승인
                      <br />
                      2023, 05, 12
                    </button>
                  </td>
                </tr>
                {[1, 2, 3, 4, 5, 6, 7].map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <td>{13 - idx}</td>
                      <td className="td_date">2023, 05, 20 12 : 30</td>
                      <td>김학생</td>
                      <td>김부모</td>
                      <td>010-1234-1324</td>
                      <td>
                        <button className="btn_link">가길동201</button>
                      </td>
                      <td>
                        <button className="btn_link">가길동201</button>
                      </td>
                      <td>
                        김담임103
                        <br />
                        2023, 01, 05
                      </td>
                      <td>
                        튼튼 홍보자료
                        <br />
                        2023, 01, 05
                      </td>
                      <td>-</td>
                    </tr>
                  );
                })}
                <tr>
                  <td>7</td>
                  <td className="td_date">2023, 05, 20 12 : 30</td>
                  <td>김학생</td>
                  <td>김부모</td>
                  <td>010-1234-1324</td>
                  <td>
                    <button className="btn_link">가길동201</button>
                  </td>
                  <td>
                    <button className="btn_link">가길동201</button>
                  </td>
                  <td>
                    김담임103
                    <br />
                    2023, 01, 05
                  </td>
                  <td>
                    튼튼 홍보자료
                    <br />
                    2023, 01, 05
                  </td>
                  <td>-</td>
                </tr>
              </tbody>
            </table>
            <Paging />
          </section>
          <section className="box">
            <div className="detail_tit dot">상세보기</div>
            <hr className="com_divider" />
            <div className="com_info white">
              <p className="name">김학생</p>
              <span className="dot" />
              <p className="info">010-1234-1234</p>
            </div>
            <div className="com_board_box">
              <div className="board_item">
                <div className="info">
                  <span className="tit">수신자</span>
                  <span className="cont">김수신103</span>
                </div>
                <div className="info">
                  <span className="tit">수신일시</span>
                  <span className="cont com_blue_txt">2023, 05, 23 10:30</span>
                </div>
                <div className="info">
                  <span className="tit">수신번호</span>
                  <span className="cont">010-1234-134</span>
                </div>
                <div className="info">
                  <span className="tit">발신자</span>
                  <span className="cont com_blue_txt">김학생 부모</span>
                </div>
                <div className="info">
                  <span className="tit">확인자</span>
                  <span className="cont com_blue_txt">김관리103, 최관리103</span>
                </div>
              </div>
              <div className="board_subject name">인 바운드 전화</div>
              <div className="board_item">
                <div className="info">
                  <span className="tit">발신자</span>
                  <span className="cont com_blue_txt">김발신103</span>
                </div>
                <div className="info">
                  <span className="tit">발신일시</span>
                  <span className="cont">2023, 05, 23 10:30</span>
                </div>
                <div className="info">
                  <span className="tit">수신번호</span>
                  <span className="cont">010-1234-134</span>
                </div>
              </div>
              <div className="board_subject name">인 바운드 전화</div>
              <div className="board_item">
                <div className="info">
                  <span className="tit">홍보책자 영역</span>
                  <span className="cont">과학탐구</span>
                </div>
                <div className="info">
                  <span className="tit">홍보책자</span>
                  <span className="cont com_blue_txt">2023 이지 홍보책자</span>
                </div>
                <div className="info">
                  <span className="tit">받는사람</span>
                  <span className="cont com_blue_txt">(교사) 김교사103</span>
                </div>
                <div className="info">
                  <span className="tit">전화번호</span>
                  <span className="cont">010-1234-1324</span>
                </div>
                <div className="info">
                  <span className="tit">배송지</span>
                  <span className="cont">서울특별시 강남구 강남대로103번지 금강빌딩103호</span>
                </div>
                <div className="info">
                  <span className="tit">메모</span>
                  <span className="cont">발송 부탁드립니다.</span>
                </div>
                <div className="info">
                  <span className="tit">홍보책자 요청자</span>
                  <span className="cont">김홍보103 / 2023, 05, 23</span>
                </div>
                <div className="info">
                  <span className="tit">승인자</span>
                  <span className="cont">김승인103 / 2023, 08,25</span>
                </div>
              </div>
              <div className="board_subject name">시범강의</div>
              <div className="board_item">
                <div className="info">
                  <span className="tit">학생명</span>
                  <span className="cont">김학생</span>
                </div>
                <div className="info">
                  <span className="tit">휴대폰 번호</span>
                  <span className="cont">010-1234-1324</span>
                </div>
                <div className="info">
                  <span className="tit">부 휴대폰</span>
                  <span className="cont">010-1234-1324</span>
                </div>
                <div className="info">
                  <span className="tit">모 휴대폰</span>
                  <span className="cont">010-1234-1324</span>
                </div>
                <div className="info">
                  <span className="tit">시범강의 일시</span>
                  <span className="cont">2023, 05, 15 11 : 30</span>
                </div>
                <div className="info">
                  <span className="tit">시범강의 장소</span>
                  <span className="cont">서울 특별시 강남구 124 빌딩 5층 금방빌라103</span>
                </div>
                <div className="info">
                  <span className="tit">승인자</span>
                  <span className="cont">김승인103 / 2023, 08,25</span>
                </div>
                <div className="info">
                  <span className="tit">시범 강의자</span>
                  <span className="cont">김승인103 / 2023, 08,25김담임103</span>
                </div>
              </div>
            </div>
          </section>
        </section>
      </div>
    </main>
  );
};

export default PRStudentList;
